import { NgModule } from '@angular/core';
import { LazyLoadImageDirective } from './lazy-load-image.directive';


@NgModule({
  exports: [LazyLoadImageDirective],
  declarations: [LazyLoadImageDirective],
})
export class LazyLoadImageModule {
}
